var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPodcastIkon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 66.9 66.9",
    style: {
      enableBackground: "new 0 0 66.9 66.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#210E3D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 33.45,
    cy: 33.45,
    r: 9.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.45,0C14.98,0,0,14.98,0,33.45c0,11.4,5.71,21.47,14.43,27.51l2.32-6.12c-6.35-4.97-10.44-12.7-10.44-21.38 c0-14.99,12.15-27.14,27.14-27.14c14.99,0,27.14,12.15,27.14,27.14c0,8.69-4.09,16.42-10.44,21.38l2.32,6.12 c8.71-6.04,14.43-16.1,14.43-27.51C66.9,14.98,51.93,0,33.45,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.45,12.34c-11.66,0-21.11,9.45-21.11,21.11c0,6.07,2.58,11.53,6.68,15.38l2.4-6.33 c-1.9-2.52-3.04-5.65-3.04-9.05c0-8.32,6.75-15.07,15.07-15.07c8.33,0,15.07,6.75,15.07,15.07c0,3.4-1.14,6.53-3.04,9.05l2.4,6.33 c4.1-3.85,6.68-9.31,6.68-15.38C54.56,21.79,45.11,12.34,33.45,12.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.52,48.4c-0.36-0.95-1.44-1.38-2.38-0.99c-1.75,0.72-3.67,1.12-5.68,1.12s-3.93-0.4-5.68-1.12 c-0.94-0.39-2.02,0.04-2.38,0.99l-5.96,15.74c-0.51,1.33,0.48,2.76,1.91,2.76h12.12h0h12.12c1.43,0,2.41-1.43,1.91-2.76L41.52,48.4 z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodcastIkon);
export default __webpack_public_path__ + "static/media/Podcast-ikon.5686abd43a04181178adc8022efb851b.svg";
export { ForwardRef as ReactComponent };